export enum UserPointerType {
  MouseUser = 'MouseUser',
  TouchUser = 'TouchUser',
}

export const IS_MOUSE_USER_CSS = 'is-mouse-user';
export const IS_TOUCH_USER_CSS = 'is-touch-user';
